import React, { useState, useContext, memo, Fragment } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Accordion,
  useAccordionButton,
  AccordionContext,
} from "react-bootstrap";

function CustomToggle({ children, eventKey, onClick }) {
  const { activeEventKey } = useContext(AccordionContext);

  const decoratedOnClick = useAccordionButton(eventKey, (active) =>
    onClick({ state: !active, eventKey: eventKey })
  );

  const isCurrentEventKey = activeEventKey === eventKey;

  return (
    <Link
      to="#"
      aria-expanded={isCurrentEventKey ? "true" : "false"}
      className="nav-link"
      role="button"
      onClick={(e) => {
        decoratedOnClick(isCurrentEventKey);
      }}
    >
      {children}
    </Link>
  );
}

const VerticalNav = memo((props) => {
  const [activeMenu, setActiveMenu] = useState(false);
  const [active, setActive] = useState("");
  //location
  let location = useLocation();
  return (
    <Fragment>
      <Accordion as="ul" className="navbar-nav iq-main-menu">
        {/* <li className="nav-item static-item">
          <Link className="nav-link static-item disabled" to="#" tabIndex="-1">
            <span className="default-icon">Home</span>
            <span className="mini-icon">-</span>
          </Link>
        </li> */}
        <li
          className={`${
            location.pathname === "/dashboard" ? "active" : ""
          } nav-item `}
        >
          <Link
            className={`${
              location.pathname === "/dashboard" ? "active" : ""
            } nav-link `}
            aria-current="page"
            to="/dashboard"
            onClick={() => {}}
          >
            <i className="icon">
              <svg
                width="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.4"
                  d="M16.0756 2H19.4616C20.8639 2 22.0001 3.14585 22.0001 4.55996V7.97452C22.0001 9.38864 20.8639 10.5345 19.4616 10.5345H16.0756C14.6734 10.5345 13.5371 9.38864 13.5371 7.97452V4.55996C13.5371 3.14585 14.6734 2 16.0756 2Z"
                  fill="currentColor"
                ></path>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M4.53852 2H7.92449C9.32676 2 10.463 3.14585 10.463 4.55996V7.97452C10.463 9.38864 9.32676 10.5345 7.92449 10.5345H4.53852C3.13626 10.5345 2 9.38864 2 7.97452V4.55996C2 3.14585 3.13626 2 4.53852 2ZM4.53852 13.4655H7.92449C9.32676 13.4655 10.463 14.6114 10.463 16.0255V19.44C10.463 20.8532 9.32676 22 7.92449 22H4.53852C3.13626 22 2 20.8532 2 19.44V16.0255C2 14.6114 3.13626 13.4655 4.53852 13.4655ZM19.4615 13.4655H16.0755C14.6732 13.4655 13.537 14.6114 13.537 16.0255V19.44C13.537 20.8532 14.6732 22 16.0755 22H19.4615C20.8637 22 22 20.8532 22 19.44V16.0255C22 14.6114 20.8637 13.4655 19.4615 13.4655Z"
                  fill="currentColor"
                ></path>
              </svg>
            </i>
            <span className="item-name">Dashboard</span>
          </Link>
        </li>

        <li>
          <hr className="hr-horizontal" />
        </li>

        <li className="nav-item">
          <Link
            className={`${
              location.pathname === "/dashboard/partners" ? "active" : ""
            } nav-link`}
            to="dashboard/partners"
          >
            <i className="icon">
              <img
                src="/partners.png"
                alt="Department Icon"
                style={{ height: "24px", width: "24px" }}
              />
            </i>
            <span className="item-name">Partners</span>
          </Link>
        </li>
        <li>
          <hr className="hr-horizontal" />
        </li>
        {/* <li className="nav-item static-item">
                    <Link className="nav-link static-item disabled" to="#" tabIndex="-1">
                        <span className="default-icon">Elements</span>
                        <span className="mini-icon">-</span>
                    </Link>
                </li> */}
        <li className="nav-item">
          <Link
            className={`${
              location.pathname === "/dashboard/roles" ? "active" : ""
            } nav-link`}
            to="dashboard/roles"
          >
            <i className="icon">
              <svg
                class="icon-32"
                width="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                {" "}
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.9849 15.3462C8.11731 15.3462 4.81445 15.931 4.81445 18.2729C4.81445 20.6148 8.09636 21.2205 11.9849 21.2205C15.8525 21.2205 19.1545 20.6348 19.1545 18.2938C19.1545 15.9529 15.8735 15.3462 11.9849 15.3462Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>{" "}
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.9849 12.0059C14.523 12.0059 16.5801 9.94779 16.5801 7.40969C16.5801 4.8716 14.523 2.81445 11.9849 2.81445C9.44679 2.81445 7.3887 4.8716 7.3887 7.40969C7.38013 9.93922 9.42394 11.9973 11.9525 12.0059H11.9849Z"
                  stroke="currentColor"
                  stroke-width="1.42857"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>{" "}
              </svg>
            </i>
            <span className="item-name">Roles</span>
          </Link>
        </li>
        <li>
          <hr className="hr-horizontal" />
        </li>
        <li className="nav-item">
        <Link
            className={`${
              location.pathname === "/dashboard/users" ? "active" : ""
            } nav-link`}
            to="dashboard/users"
          >
            <i className="icon">
              <svg
                class="icon-32"
                width="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                {" "}
                <path
                  d="M17.8877 10.8967C19.2827 10.7007 20.3567 9.50473 20.3597 8.05573C20.3597 6.62773 19.3187 5.44373 17.9537 5.21973"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>{" "}
                <path
                  d="M19.7285 14.2505C21.0795 14.4525 22.0225 14.9255 22.0225 15.9005C22.0225 16.5715 21.5785 17.0075 20.8605 17.2815"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>{" "}
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.8867 14.6638C8.67273 14.6638 5.92773 15.1508 5.92773 17.0958C5.92773 19.0398 8.65573 19.5408 11.8867 19.5408C15.1007 19.5408 17.8447 19.0588 17.8447 17.1128C17.8447 15.1668 15.1177 14.6638 11.8867 14.6638Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>{" "}
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.8869 11.888C13.9959 11.888 15.7059 10.179 15.7059 8.069C15.7059 5.96 13.9959 4.25 11.8869 4.25C9.7779 4.25 8.0679 5.96 8.0679 8.069C8.0599 10.171 9.7569 11.881 11.8589 11.888H11.8869Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>{" "}
                <path
                  d="M5.88509 10.8967C4.48909 10.7007 3.41609 9.50473 3.41309 8.05573C3.41309 6.62773 4.45409 5.44373 5.81909 5.21973"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>{" "}
                <path
                  d="M4.044 14.2505C2.693 14.4525 1.75 14.9255 1.75 15.9005C1.75 16.5715 2.194 17.0075 2.912 17.2815"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>{" "}
              </svg>
            </i>
            <span className="item-name">Users</span>
          </Link>
        </li>
        <li>
          <hr className="hr-horizontal" />
        </li>
        <li className="nav-item">
        <Link
            className={`${
              location.pathname === "/dashboard/departments" ? "active" : ""
            } nav-link`}
            to="dashboard/departments"
          >
            <i className="icon">
              <img
                src="/department.png"
                alt="Department Icon"
                style={{ height: "24px", width: "24px" }}
              />
            </i>
            <span className="item-name">Department</span>
          </Link>
        </li>

        <li>
          <hr className="hr-horizontal" />
        </li>
        <li className="nav-item">
        <Link
            className={`${
              location.pathname === "/dashboard/groups" ? "active" : ""
            } nav-link`}
            to="dashboard/groups"
          >
            <i className="icon">
              <img
                src="/groups.png"
                alt="Department Icon"
                style={{ height: "24px", width: "24px" }}
              />
            </i>
            <span className="item-name">Groups</span>
          </Link>
        </li>
        <li>
          <hr className="hr-horizontal" />
        </li>
        <li className="nav-item">
        <Link
            className={`${
              location.pathname === "/dashboard/services" ? "active" : ""
            } nav-link`}
            to="dashboard/services"
          >
            <i className="icon">
              <img
                src="/services.png"
                alt="Department Icon"
                style={{ height: "24px", width: "24px" }}
              />
            </i>
            <span className="item-name">Services</span>
          </Link>
        </li>
        <li>
          <hr className="hr-horizontal" />
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/">
            <i className="icon">
              <img
                src="/plans.png"
                alt="Department Icon"
                style={{ height: "24px", width: "24px" }}
              />
            </i>
            <span className="item-name">Plans</span>
          </Link>
        </li>
        <li>
          <hr className="hr-horizontal" />
        </li>
        <li className="nav-item">
          <Link
            className={`${
              location.pathname === "/dashboard/license" ? "active" : ""
            } nav-link`}
            to="/dashboard/license"
          >
            <i className="icon">
              <img
                src="/license.png"
                alt="Department Icon"
                style={{ height: "24px", width: "24px" }}
              />
            </i>
            <span className="item-name">License</span>
          </Link>
        </li>
        <li>
          <hr className="hr-horizontal" />
        </li>
        <li className="nav-item">
          <Link
            className={`${
              location.pathname === "/dashboard/bill" ? "active" : ""
            } nav-link`}
            to="/dashboard/bill"
          >
            <i className="icon">
              <img
                src="/license.png"
                alt="Department Icon"
                style={{ height: "24px", width: "24px" }}
              />
            </i>
            <span className="item-name">Bill Desk</span>
          </Link>
        </li>
        <li>
          <hr className="hr-horizontal" />
        </li>
        <li className="nav-item">
          <Link
            className={`${
              location.pathname === "/dashboard/settings" ? "active" : ""
            } nav-link`}
            to="/dashboard/settings"
          >
            <i className="icon">
              <img
                src="/license.png"
                alt="Department Icon"
                style={{ height: "24px", width: "24px" }}
              />
            </i>
            <span className="item-name">Settings</span>
          </Link>
        </li>
      </Accordion>
    </Fragment>
  );
});

export default VerticalNav;
